export const PrimaryColor = '#ff8c00';
export const SecondaryColor = '#FFD1A4';
export const ThirdColor = '#D0D0D0';


